import React from "react";

export default function AccountContent({ children, className = "" }) {
  return (
    <div className={`profile_page ${className}`.trim()}>
      <div className="container">{children}</div>
    </div>
  );
}
